import {useCallback} from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import './PropertyEstimate.scss';
import Currency from 'components/Currency';
import {PropertyEstimateTooltipContainer} from 'components/PropertyEstimateTooltip';
import {getConfidenceFromAvm} from 'lib/AvmUtils';
import LoadingPanel from '../LoadingPanel/LoadingPanel';

/**
 * Property estimate component to show either the property estimate or a placeholder
 * @param isRental
 * @param avm
 * @param isLoading
 * @returns {JSX.Element}
 * @constructor
 */
const PropertyEstimate = (
  {
    isRental,
    avm,
    isLoading,
  }
) => {
  const hasEstimate = useCallback(() => {
    const confidence = getConfidenceFromAvm(avm, isRental);
    return Boolean(confidence.label !== 'No');
  }, [avm, isRental]);
  return (
    <div className="PropertyEstimate" data-testid="PropertyEstimate">
        <Typography
            variant="fontWeight600"
            className="title"
        >
            Estimated Value
        </Typography>
      <LoadingPanel isLoading={isLoading} data-testid="LoadingPanel">
      <span className="details">{hasEstimate() ? <Currency currency={avm.estimate}/> : 'not available'}</span>
        {hasEstimate() && (
          <span className="tooltip"><PropertyEstimateTooltipContainer avm={avm} isRental={isRental}/></span>
        )}
      </LoadingPanel>
    </div>
  );
};

PropertyEstimate.propTypes = {
  avm: PropTypes.shape({
    confidence: PropTypes.string,
    estimate: PropTypes.number,
  }),
  isRental: PropTypes.bool,
  isLoading: PropTypes.bool,
};

PropertyEstimate.defaultProps = {
  isLoading: true,
};

export default PropertyEstimate;